var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isDesktop)?_c('section',{ref:"animateRef",staticClass:"parachute-wrapper fadeInDown",on:{"click":_vm.click}},[_c('img',{staticClass:"parachute-icon",attrs:{"src":require(`@/assets/images/activities/fission/parachute.png`),"alt":"logo"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }